(() => {
  const name = document.documentElement.lang.startsWith('fr') ? 'Contacter Tonsor & Cie sur WhatsApp (nouvelle fenêtre)' : 'Contact Tonsor & Cie on WhatsApp (opens in a new window)';
  const label = root => {
    root.querySelectorAll('a.wfb-platform-btn[data-platform="whatsapp"]').forEach(link => {
      if (!link.hasAttribute('aria-label')) link.setAttribute('aria-label', name);
    });
  };
  label(document);
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('a.wfb-platform-btn[data-platform="whatsapp"]')) node.setAttribute('aria-label', name);
      label(node);
    }
  });
  observer.observe(document.body, {childList:true, subtree:true});
})();
